import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  prefixCurriculumName,
  setSubChildId,
} from "Administrator/modules/AdministratorModule";
import {
  getSelectedCurriculumId,
  getCurrentCurriculumProgramType,
} from "modules/CommonSelectors";
import {
  CURRICULUM_TYPE_UBD,
  GRADE_SCALE_SETUP,
  GRADE_BOUNDARY_SETUP,
} from "Constants/stringConstants";
import TermGradeScales from "Administrator/commonComponents/GradeScaleSetup/routes/TermGradeScales";
import GradeBoundaryTemplates from "Administrator/routes/DPAcademicSetup/routes/GradeBoundaries/routes/GradeBoundaryTemplates";
export default store => ({
  path: "grade-boundary-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/commonComponents/GradeScaleSetup/modules/GradeScalesModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "gradeScales",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = getSelectedCurriculumId(state);
    const curriculumProgramType = getCurrentCurriculumProgramType(state);
    const childIdToUse =
      curriculumProgramType === CURRICULUM_TYPE_UBD
        ? GRADE_SCALE_SETUP
        : GRADE_BOUNDARY_SETUP;
    const childId = store.dispatch(
      prefixCurriculumName({
        childId: childIdToUse,
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(childId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
  childRoutes: [GradeBoundaryTemplates(store), TermGradeScales(store)],
});
